import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

/**
 * Prefetching PDP APIs on hover experiment
 */
export const FE_PREFETCH_PDP_APIS_HOVER_250409 = experiment({
  name: "FE_PREFETCH_PDP_APIS_HOVER_250409",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-07-01",
  defaultValue: IThreeVariantXP.Bucket.CONTROL,
  productArea: "PRODUCT_PAGE",
});
